// ticket-dag-red-window-dry-run-warning.ts
//
// Phase 06j (F-48, R3): warn about a FRESH DAG shape that the RED-window rule
// would stall, before any money is spent. Dry run of the real scheduler from
// all-todo, every dispatch assumed to succeed; it stops with tickets left AND a
// non-empty `held` ⇔ the rule (not the DAG itself) is what stops it ⇒ the first
// explainer line becomes the warning. Scope (B5): the DAG's SHAPE only — a
// stuck mid-mission state (blocked implement, beta.8 order) shows up in the
// `run` stall reason, not here. Warning only, never a reject.
import { nextReadyTicket, type TicketRuntimeStatus } from "./scheduler.js";
import { explainRedWindowConflict } from "./scheduler-red-window-stall-explainer.js";
import type { Ticket } from "./schemas/ticket-schema.js";

const LINE_PREFIX = "red_window_conflict: ";

/** `red_window_conflict dự kiến: …` or `undefined`; `missionId` (G2) puts `--mission` in the fix. */
export function findRedWindowConflictWarning(
  tickets: Ticket[],
  missionId?: string,
): string | undefined {
  const status: Record<string, TicketRuntimeStatus> = Object.fromEntries(
    tickets.map((t) => [t.id, "todo"]),
  );
  for (let i = 0; i < tickets.length; i += 1) {
    const next = nextReadyTicket({ tickets, ticketStatus: status });
    if (next === undefined) break;
    status[next.id] = "done";
  }
  if (!tickets.some((t) => status[t.id] === "todo")) return undefined;
  const [first] = explainRedWindowConflict(tickets, status, missionId);
  if (first === undefined) return undefined;
  const detail = first.startsWith(LINE_PREFIX) ? first.slice(LINE_PREFIX.length) : first;
  return `red_window_conflict dự kiến: ${detail}`;
}
